import React, {useEffect, useState} from 'react';
import Layout from "../Layout";
import {sendDeposit} from "../../Services/apis";
import {SET_ACTION_PROP, SET_LOADING_PROP} from "../../Redux/types";
import {useDispatch, useSelector} from 'react-redux';
import {goBack} from "../../Utils/helpers";

const Deposit = ({history}) => {
    const [amount, setAmount] = useState('');
    const {SportsbookGlobalVariable} = useSelector((state) => state.sportsBook);
    const {isAuthenticated} = useSelector(state => state.auth);

    useEffect(() => {
        if(!isAuthenticated)
            history.replace('/');
    },  [isAuthenticated]);

    const dispatch = useDispatch();

    const updateAmount = (value) => {
        if (value === 0) {
            // @ts-ignore
            setAmount(0);
            return;
        }

        let currentAmount = amount;
        if (currentAmount === ''){
            // @ts-ignore
            currentAmount = 0;
        }
        const newAmount = currentAmount + value
        setAmount(newAmount);
    }

    const submit = (e) => {
        e.preventDefault();
        if(amount < SportsbookGlobalVariable.MinDeposit) {
            dispatch({
                type: SET_ACTION_PROP,
                payload: {
                    show: true,
                    title: 'Error',
                    message: 'The minimum deposit amount is ' + SportsbookGlobalVariable.MinDeposit
                }
            });
            return;
        }
        dispatch({type: SET_LOADING_PROP, payload: {show: true, message: ''}});

        sendDeposit({amount}).then((res) => {
            dispatch({type: SET_LOADING_PROP, payload: {show: false, message: ''}})

            if (res.success) {
                setAmount('');
                dispatch({type: SET_ACTION_PROP, payload: {show: true, title: 'Success', message: 'Deposit request has been sent. Please follow the instructions on your mobile device.'}})
            }
            // console.log(res);
        }).catch(err => {
            dispatch({type: SET_LOADING_PROP, payload: {show: false, message: ''}});
            dispatch({type: SET_ACTION_PROP, payload: {show: true, title: 'Error', message: 'Unable to process request. Please try again'}});
        })
    }


    return (
        <Layout
            headerLeft={
                <div className="h-s__wrap-trigger px15 py10" onClick={() => goBack(history)}>
                    <i className="icon-back" />
                    <span className="d-ib ml5">Back</span>
                </div>
            }>
            <div className="page-title"> Instant Deposit Cards</div>
            <div className="page__body p15">
                <div className="form">
                    <div className="clear-both"/>
                    <div className="">

                        <div className="form-row">
                            <div className="form-label"><strong> Deposit Amount ({SportsbookGlobalVariable.Currency})</strong></div>
                            <div className="form-input">
                                <input name="amount"
                                       className="big" type="number"
                                       step="100" maxLength={5} min={SportsbookGlobalVariable.MinDeposit} max="10000"
                                       value={amount} onChange={(e) => setAmount(e.target.value)}
                                />
                                <div className="form-input--stake"> Min {SportsbookGlobalVariable.MinDeposit}</div></div>
                            <div className="quickstake mt10">
                                <div className="quickstake__item" onClick={() => updateAmount(0)}> Clear</div>
                                <div className="quickstake__item" onClick={() => updateAmount(100)}> +100</div>
                                <div className="quickstake__item" onClick={() => updateAmount(200)}> +200</div>
                                <div className="quickstake__item" onClick={() => updateAmount(500)}> +500</div>
                                <div className="quickstake__item" onClick={() => updateAmount(1000)}> +1000</div>
                            </div>
                        </div>
                        <button
                            onClick={submit}
                            className="btn mt20 mb20 w-full">Make Payment</button>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Deposit;
